import $ from "jquery";
import moment from "moment";
global.jQuery = $;
import "bootstrap-sass";
import * as bootbox from "bootbox";
import "bootbox/bootbox.locales";
import "smartmenus";
import "smartmenus-bootstrap";
import "bootstrap-multiselect";
import * as kendo from "@progress/kendo-ui/js/kendo.grid";
import "@progress/kendo-ui/js/kendo.tooltip";
import "@progress/kendo-ui/js/cultures/kendo.culture.fr-FR";
import "@progress/kendo-ui/js/messages/kendo.messages.fr-FR";
import Seed from "DMS/Seed/All";
import * as modal from "DMS/Utils/modal";
import showVersion from "DMS/Utils/version";
import imprimerForm from "DMS/Utils/printer";
import { uniqid } from "DMS/Utils/lib";
import * as processLauncher from "DMS/Utils/processLauncher";
import * as checkFeatures from "DMS/Utils/checkFeatures";
import * as homeController from "DMS/Controllers/homeController";
import * as eservicesController from "DMS/Controllers/eservicesController";
import * as listController from "DMS/Controllers/listController";
import * as formController from "DMS/Controllers/formController";
import * as kendoController from "DMS/Controllers/kendoController";
import * as uploadController from "DMS/Controllers/uploadController";
import * as planningController from "DMS/Controllers/planningController";
import * as geolocController from "DMS/Controllers/geolocController";
import * as smartController from "DMS/Controllers/smartController";
import * as loginController from "DMS/Controllers/loginController";
import { SignatureController } from "./SignatureController";
// @todo refacto des controlleurs ? Cette fonction doit aller où ? homeController ?
export function confirmAction(message, callback) {
    bootbox.confirm(message, function (result) {
        if (callback && typeof (callback) === 'function') {
            callback(result);
        }
    });
}
/**
 * Callback to manage timer
 * @type Function Callback
 */
export let waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = uniqid();
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();
// @todo : injection de service
export function registerPublicDomain() {
    moment.locale(culture.substr(0, 2));
    kendo.culture(culture);
    bootbox.setLocale(culture);
    window.jQuery = $;
    window.$ = $;
    window.bootbox = bootbox;
    window.Seed = Seed;
    window.createChart = homeController.createChart;
    window.JSONToCSV = homeController.JSONToCSV;
    window.changeAlink = homeController.changeAlink;
    window.showModule = eservicesController.showModule;
    window.openLocalisation = eservicesController.openLocalisation;
    window.ProcessPHP = eservicesController.ProcessPHP;
    window.initializePHPForm = eservicesController.initializePHPForm;
    window.showInterface = eservicesController.showInterface;
    window.initializeImport = eservicesController.initializeImport;
    window.envoiMail = eservicesController.envoiMail;
    window.callList = listController.callList;
    window.initializeSearch = listController.initializeSearch;
    window.changeChevron = listController.changeChevron;
    window.changeFilter = listController.changeFilter;
    window.refreshList = listController.refreshList;
    window.initList = listController.initList;
    window.rqList = listController.rqList;
    window.encode = kendoController.encode;
    window.textAreaTooltip = kendoController.textAreaTooltip;
    window.save = kendoController.save;
    window.edit = kendoController.edit;
    window.dataBound = kendoController.dataBound;
    window.dataBinding = kendoController.dataBinding;
    window.changeUserSetting = kendoController.changeUserSetting;
    window.detailExpand = kendoController.detailExpand;
    window.dateTimeEditor = kendoController.dateTimeEditor;
    window.timeEditor = kendoController.timeEditor;
    window.textareaEditor = kendoController.textareaEditor;
    window.dropDownFilterEditor = kendoController.dropDownFilterEditor;
    window.dropDownEditor = kendoController.dropDownEditor;
    window.errorHandler = kendoController.errorHandler;
    window.resizeScreenKendo = kendoController.resizeScreenKendo;
    window.rebuildProcess = kendoController.rebuildProcess;
    window.exportCSV = kendoController.exportCSV;
    window.buttonTrashManagment = kendoController.buttonTrashManagment;
    window.fichierTemplate = kendoController.fichierTemplate;
    window.uploadFichierTemplate = kendoController.uploadFichierTemplate;
    window.openUploadFormModal = kendoController.openUploadFormModal;
    window.removeFilterFromGrid = kendoController.removeFilterFromGrid;
    window.lastActionBtnClicked = kendoController.lastActionBtnClicked;
    window.callForm = formController.callForm;
    window.callFormAngular = formController.callFormAngular;
    window.initializeForm = formController.initializeForm;
    window.smoothScrolling = formController.smoothScrolling;
    if (window.signaturePadClass === undefined) {
        window.signaturePadClass = new SignatureController();
    }
    window.imprimerForm = imprimerForm;
    window.Process = processLauncher.process;
    window.ProcessAction = processLauncher.processAction;
    window.ProcessUpdate = processLauncher.processUpdate;
    window.checkFeatures = checkFeatures;
    window.openModalIframe = modal.openModalIframe;
    window.closeModalIframe = modal.closeModalIframe;
    window.showVersion = showVersion;
    window.uploadController = uploadController;
    window.smartController = smartController;
    window.planningController = planningController;
    window.getAndDisplayCgu = loginController.getAndDisplayCgu;
    window.refreshAllGeoloc = geolocController.refreshAllGeoloc;
    window.showTechData = geolocController.showTechData;
    window.changeImage = geolocController.changeImage;
    window.changeActiveButton = geolocController.changeActiveButton;
    window.toggleTraffic = geolocController.toggleTraffic;
    window.toggleFlyPath = geolocController.toggleFlyPath;
    window.showTechTour = geolocController.showTechTour;
    window.map = null;
    window.bounds = null;
    window.infowindow = null;
    window.marker = null;
    window.trafficLayer = undefined;
    window.confirmAction = confirmAction;
    window.usergroup = null;
}
//# sourceMappingURL=commonController.js.map